export default __webpack_public_path__ + "static/bg-clean1-ffb651562a758bb5188c9af7c59ccbd6.jpeg";